import React from "react";
import { Controller } from "react-hook-form";
import { SettingsInput } from "./SettingsInput";
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import { ControlledInputProps, FieldErrorText } from "./ControlledInput";

const ControlledEmailInput: React.FC<ControlledInputProps> = ({
  control,
  name,
  label,
  placeholder,
  defaultValue = "",
  rules = {},
}) => (
  <Controller
    control={control}
    name={name}
    defaultValue={defaultValue}
    rules={rules}
    render={({ field: { value, onChange }, fieldState: { error } }) => (
      <div className="w-full">
        <div className="relative w-full">
          <EnvelopeIcon
            className="absolute left-3 top-1/2 transform -translate-y+1/2 w-6 h-6 stroke-gray-400 fill-white"
          />
          <SettingsInput
            value={value}
            isError={!!error}
            onChange={(e) => onChange(e.target.value)}
            label={label}
            placeholder={placeholder}
            inputClasses={"w-full pl-12"}
          />
        </div>
        <FieldErrorText message={error?.message} />
      </div>
    )}
  />
);

export default ControlledEmailInput;
